import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import Typography from "@material-ui/core/Typography";

export default class ChatURLDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
        <form>
          <DialogContent style={{ width: 400, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText />
            <TextField
              autoFocus
              // placeholder={languages.tournament.chatURLPlaceholder}
              onChange={this.props.handleChatURLChange}
              fullWidth
              // label={languages.tournament.chatURL}
              name="chatURL"
              value={this.props.chatURL || ""}
            />
          </DialogContent>
          {this.props.errorMessage && (
            <DialogActions>
              <div>
                <Typography style={{ color: "red" }}>
                  {this.props.errorMessage}
                </Typography>
              </div>
            </DialogActions>
          )}
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.props.handleSubmit}
              variant="contained"
              color="primary"
              type="submit"
            >
              {languages.general.save}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
